import { render, staticRenderFns } from "./BackHeader2.vue?vue&type=template&id=14ed98c7&"
import script from "./BackHeader2.vue?vue&type=script&lang=js&"
export * from "./BackHeader2.vue?vue&type=script&lang=js&"
import style0 from "./BackHeader2.vue?vue&type=style&index=0&id=14ed98c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports